export default "__VITE_ASSET__BZaxkPuv__"